import I18n from '@/utils/language'
export const filterLang = lang => {
  if (!lang) return;
  let i
  switch (lang) {
    case 'zh':
      i = '中文'
      break;
    case 'en':
      i = 'English'
      break;
    case 'ru':
      i = 'Русский язык '
      break;
    default:
      break;
  }
  return i;
};

//	全局时间过滤
export const filterDate = date => {
  if (!date) return;

  let filterHandle = t => (t < 10 ? "0" + t : t);
  let a = new Date(date);
  let n = a.getFullYear();
  let y = filterHandle(a.getMonth() + 1);
  let r = filterHandle(a.getDate());
  let s = filterHandle(a.getHours());
  let f = filterHandle(a.getMinutes());
  let m = filterHandle(a.getSeconds());
  let i = `${n}/${y}/${r} ${s}:${f}:${m}`;
  return i;
};

//	全局时间过滤
export const formatDate = (value, fmt) => {
  var crtTime = new Date(value)
  if (fmt) return dateFtt(fmt, crtTime)
  return dateFtt('yyyy-MM-dd hh:mm:ss', crtTime)
};

let dateFtt = (fmt, date) => {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

//	过滤笔记/文件夹
export const filterNotesType = type => {
  let str
  switch (type) {
    case 0:
      str = I18n.t('common.folder')
      break;
    case 1:
      str = I18n.t('common.note')
      break;

    default:
      break;
  }
  return str;
};


// 文件大小添加单位
export const filterSize = value => {
  if (value === null || value === "" || !value) {
    return "0 B";
  }
  let unitArr = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let index = 0;
  let srcsize = parseFloat(value);
  index = Math.floor(Math.log(srcsize) / Math.log(1024));
  var size = srcsize / Math.pow(1024, index);
  //  保留的小数位数
  size = size.toFixed(2);
  return size + unitArr[index];
};